<template>
  <div>
    <yd-preview :buttons="[]" v-for="(item, key) in codeList" :key="key">
      <yd-preview-header class="ticket_name">
        <div slot="left">会议</div>
        <div slot="right" style="color: #FFFFFF;">{{item.fair_name}}</div>
      </yd-preview-header>
      <div v-if="item.contacts.length > 0">
        <yd-preview-item class="first_item">
          <div slot="left">姓名</div>
          <div slot="right">{{item.contacts[0].user_name}}</div>
        </yd-preview-item>
        <yd-preview-item>
          <div slot="left">公司名称</div>
          <div slot="right">{{item.contacts[0].company}}</div>
        </yd-preview-item>
      </div>
      <yd-preview-item>
        <div slot="left">参会凭证</div>
        <div slot="right">{{item.qiandao.code}}</div>
      </yd-preview-item>
      <yd-preview-item>
        <div slot="left">编号</div>
        <div slot="right">{{item.ordersn}}</div>
      </yd-preview-item>
      <yd-preview-item class="last_item">
        <div slot="left"><span style="color: #25a4bb">{{item.qiandao.is_qiandao === '0' ? '未签到' : '已签到'}}</span></div>
        <div slot="right"><a :href="item.qiandao.code_img">出示参会凭证</a></div>
      </yd-preview-item>
    </yd-preview>
  </div>
</template>

<script type="text/babel">
import axios from 'axios'
export default {
  data () {
    return {
      params: this.$route.params,
      phone: '',
      code: '',
      codeStatus: false,
      codeList: []
    }
  },
  methods: {
    codeSearch () {
      let that = this
      let data = {fair_id: this.params.id, page: 1, uid: this.$store.state.uid}
      axios.defaults.headers.post['Authorization'] = 'Bearer ' + this.$store.state.token
      axios
        .post('/fair/my-ticket', data)
        .then(this.codeSearchSucc)
        .catch(function (res) {
          localStorage.clear()
          that.$dialog.toast({mes: '身份过期请重新登录'})
          window.location.reload()
        })
    },
    codeSearchSucc (res) {
      res = res.data
      if (res.status) {
        this.codeList = res.data
      } else {
        this.$dialog.toast({
          mes: res.msg,
          icon: 'error',
          timeout: 1500
        })
      }
      console.log(res)
    },
    HistoryBack () {
      window.history.back()
    },
    checkLogin () {
      if (!this.$store.state.uid) {
        this.$router.push({path: '/' + this.params.id + '/single-my'})
      }
    }
  },
  mounted () {
    this.checkLogin()
    this.codeSearch()
  }
}
</script>

<style lang="stylus" scoped>
  @css{
    .voucher{
      overflow:hidden;
      margin:0 0.2rem;
    }
    .voucher li{
      overflow:hidden;
      background:#fff;
      margin-bottom:0.4rem;
    }
    .voucher li div{
      padding:0.2rem 0.3rem;
      overflow:hidden;
      font-size:0.32rem;
      color:#666;
    }
    .voucher li div .right{
      float:right;
    }
    .voucher li  img{
      display:block;
      width:77%;
      margin:0 auto;
      margin-bottom:0.2rem;
    }
    .voucher li p{
      padding:0 0.3rem;
      font-size:0.32rem;
      color:#666;
    }
    .voucher li a{
      display:block;
      padding:0.25rem 0.3rem;
      border-top:1px solid #efeff0;
      margin-top:0.2rem;
      color:#7f8185;
      font-size:0.3rem;
    }
    .yd-preview{
      width: calc(100% - .4rem);
      margin: .2rem auto;
      border-radius: .2rem;
    }
    .yd-preview-header{
      margin: 0;
      margin-bottom: .2rem;
      padding:0 .4rem;
      border-top-left-radius: .2rem;
      border-top-right-radius: .2rem;
      background-color: #04BE02;
      color: #fff;
      font-size: .32rem;
      font-family:"microsoft yahei";
      height: .88rem;
    }
    .yd-preview-item{
      line-height: .32rem;
      padding: 0 .4rem;
      padding-bottom: .28rem;
    }
    .yd-preview-item>:last-child{
      line-height: .32rem;
    }
    .first_item{
      padding-top: .2rem;
    }
    .last_item{
      padding-top: .1rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/template1/SingleTicket.vue